// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DiagnosisModel } from './diagnosisModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DiagnosisSearchResponseModel {
    'diagnoses'?: Array<DiagnosisModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DiagnosisSearchResponseModel>> = [
        {
            "name":     "diagnoses",
            "baseName": "diagnoses",
            "type":     "Array<DiagnosisModel>"
        },
    ];

    static getAttributeTypeMap() {
        return DiagnosisSearchResponseModel.attributeTypeMap;
    }
}
